<script setup lang="ts">
  import { copyToClipboard } from '@/utils'
  import { HierarchicAplosFileService } from '../services/HierarchicAplosFileService'
  import { CircleAlert } from 'lucide-vue-next'
  import { HierarchicAplosFileViewModel } from '../models/HierarchicAplosFileViewModel'

  const props = defineProps<{
    record: HierarchicAplosFileViewModel
    index?: number
    selectable?: boolean
    onCellClick?: (record: any, e?: Event) => void
  }>()

  function handleClick(e?: Event) {
    if (props.selectable && props.onCellClick) {
      props.onCellClick(props.record, e)
    } else {
      copyToClipboard(`file: ${props.record?.name}\nid: ${props.record?.id}`)
    }
  }
</script>

<template>
  <!-- cell allows shrinking down to 150px; filename text will ellipsize on overflow -->
  <div :class="[{ 'cursor-pointer': selectable }, 'file-name-cell']" @click="handleClick">
    <div>
      <span class="file-name-inline">
        <a-tooltip
          v-if="HierarchicAplosFileService.getFileErrorsForManager(record)?.length"
          class="inline-tooltip text-red-500"
        >
          <template #title>
            <div style="white-space: pre-wrap">
              {{ HierarchicAplosFileService.getFileErrorsForManager(record).join('\n\n') }}
            </div>
          </template>
          <CircleAlert class="file-error-icon size-5" />
        </a-tooltip>

        <a-tooltip class="inline-tooltip" :title="HierarchicAplosFileService.getFileDisplayNameForFile(record)">
          <span class="file-name-text-inner">
            {{ HierarchicAplosFileService.getFileDisplayNameForFile(record) }}
          </span>
        </a-tooltip>
      </span>
    </div>
  </div>
</template>

<style scoped>
  .inline-tooltip {
    display: inline-flex;
    align-items: center;
  }
  /* constrain the cell so long names truncate with ellipsis */
  .file-name-cell {
    min-width: 150px;
    max-width: 300px;
    overflow: hidden;
  }
  .file-name-inline {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    /* allow inner text to shrink/overflow correctly */
    min-width: 0;
    max-width: 100%;
  }
  .file-error-icon {
    margin-right: 0;
  }
  /* single-line filename with ellipsis */
  .file-name-text-inner {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
</style>
